(function () {
  const STORAGE_KEY = "nakai_announcement_dismissed";

  const hideAnnouncement = (section) => {
    if (section) section.style.display = "none";
    document.body.classList.add("announcement-hide");
    document.documentElement.style.setProperty("--announcement-height", "0px");
    document.documentElement.style.setProperty("--ann-height", "0px");
  };

  document.querySelectorAll(".announcement-bar__close-button").forEach((btn) => {
    const section = btn.closest(".section-announcement");
    const bar = btn.closest("[data-announcement-key]");
    const key = bar ? bar.dataset.announcementKey : "1";

    try {
      if (!window.Shopify?.designMode && localStorage.getItem(STORAGE_KEY) === key) {
        hideAnnouncement(section);
      }
    } catch (e) {
      // Storage unavailable (private mode / blocked): bar stays visible
    }

    btn.addEventListener("click", () => {
      hideAnnouncement(section);
      try {
        localStorage.setItem(STORAGE_KEY, key);
      } catch (e) {
        // Storage unavailable: dismissal lasts for this page view only
      }
    });
  });
})();
